/**
 * Reusable Loading State Component
 * Consistent loading UI across all dashboards
 */

import React from 'react';
import { COLORS, SPACING, TYPOGRAPHY } from '../../constants/theme';

export interface LoadingStateProps {
  message?: string;
  fullPage?: boolean;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Loading...',
  fullPage = true
}) => {
  const containerStyle: React.CSSProperties = fullPage
    ? {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        padding: SPACING['2xl'],
      }
    : {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: SPACING.xl,
      };

  return (
    <div style={containerStyle}>
      {/* Spinner */}
      <div
        style={{
          width: '40px',
          height: '40px',
          border: `4px solid ${COLORS.gray[200]}`,
          borderTop: `4px solid ${COLORS.primary.main}`,
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          marginBottom: SPACING.lg,
        }}
      />

      {/* Message */}
      <div
        style={{
          fontSize: TYPOGRAPHY.fontSize.base,
          color: COLORS.text.secondary,
          fontWeight: TYPOGRAPHY.fontWeight.medium,
        }}
      >
        {message}
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};
